import {
	BorderedLayout,
	Button,
	DatePicker,
	DownloadPersonalInfoButton,
	Modal,
	RowItem,
	Select,
} from '@/components';
import { TIME_OPTIONS } from '@/constant';
import { getFieldDateProps, getFieldSelectProps } from '@/utils';
import { CloseOutlined } from '@ant-design/icons';
import { memo } from 'react';

import { SelectProps } from 'antd';

import { useLogic } from './logic';
import { IProps } from './type';

const CurrentSituationExcel = (props: IProps) => {
	const {
		loading,
		formik,
		onDownload,
		handleSelectTimeChange,
		handleDateChange,
		selectedPrograms,
		handleRemoveProgram,
		disabledStartDate,
		disabledEndDate,
		selectRef,
		handleSelectProgram,
		programListOptions,
	} = useLogic(props);
	const { ...rest } = props;

	const tagRender: SelectProps['tagRender'] = (props) => {
		return <div className="w-0 h-0 hidden">{props.label}</div>;
	};

	return (
		<Modal
			title="운영 현황 엑셀 다운로드"
			width={680}
			{...rest}
			destroyOnClose
			loading={loading}
		>
			<BorderedLayout>
				<RowItem label="프로그램" required>
					<div className="flex flex-col w-full">
						<Select
							{...getFieldSelectProps(formik, 'programIds')}
							showSearch
							mode="multiple"
							options={programListOptions?.data || []}
							tagRender={tagRender}
							suffixIcon={null}
							ref={selectRef}
							onSelect={handleSelectProgram}
							onDeselect={handleSelectProgram}
						/>

						<div className="flex flex-wrap ">
							{selectedPrograms?.map((program) => (
								<div
									key={program?.id}
									className="flex items-center justify-between h-6 bg-porcelain rounded-[4px] px-2 py-1 mr-2 mt-1"
								>
									<span className="text-[13px] text-font2 mr-3">
										{program?.name}
									</span>

									<span
										className="cursor-pointer text-[13px] "
										onClick={() => handleRemoveProgram(program?.id || 0)}
									>
										<CloseOutlined className="w-[10px] h-[10px]" />
									</span>
								</div>
							))}
						</div>
					</div>
				</RowItem>
				<RowItem label="조회 기간" childrenClassName="block">
					<Select
						{...getFieldSelectProps(formik, 'selectDate', { defaultValue: '' })}
						options={TIME_OPTIONS}
						onChange={handleSelectTimeChange}
					/>
					<div className="flex items-center mt-1">
						<DatePicker
							format="YYYY-MM-DD"
							{...getFieldDateProps(formik, 'startDate')}
							disabledDate={disabledStartDate}
							className="m-w-full"
							onChange={(value) => handleDateChange(value, 'start')}
						/>
						<span className="mx-3">-</span>
						<DatePicker
							format="YYYY-MM-DD"
							{...getFieldDateProps(formik, 'endDate')}
							className="m-w-full"
							disabledDate={disabledEndDate}
							onChange={(value) => handleDateChange(value, 'end')}
						/>
					</div>
				</RowItem>
			</BorderedLayout>
			<div className="flex justify-center mt-10">
				<DownloadPersonalInfoButton asChild onDownload={onDownload}>
					<Button type="primary" isMainBtn>
						다운로드
					</Button>
				</DownloadPersonalInfoButton>
			</div>
		</Modal>
	);
};

export default memo(CurrentSituationExcel);
